import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import InputItem from '../InputItem';
import Button from '../../atoms/Button';
import AuthLink from '../../atoms/AuthLink';
import Flex from '../../atoms/Flex';
import { useForm } from '@inertiajs/react';
import Notice from '../Notice';
import { useTranslation } from 'react-i18next';
const initialData = {
    email: '',
};
const PasswordForgotForm = ({ propNotice }) => {
    const { t } = useTranslation();
    const { data, setData, post, processing, errors, reset, } = useForm(initialData);
    const [notice, setNotice] = useState(propNotice);
    const handleSubmit = (e) => {
        e.preventDefault();
        try {
            post(window.location.href, {
                onSuccess: () => {
                    reset();
                },
            });
        }
        catch (e) {
            setNotice({
                type: 'error',
                text: t('password_reset.email_not_send_text'),
                title: t('password_reset.email_not_send_title'),
            });
        }
    };
    return (_jsxs(_Fragment, { children: [notice && _jsx(Notice, { ...notice }), _jsxs("form", { action: "./", method: 'post', onSubmit: handleSubmit, "data-testid": "password-forgot-form", children: [_jsx(InputItem, { label: t('user.email'), placeholder: t('user.email_placeholder'), type: "text", onChange: e => setData('email', e.target.value), error: errors?.email, value: data?.email, required: true }), _jsx(Button, { secondary: true, fullWidth: true, textAlign: "center", isLoading: processing, children: t('password_reset.request_password_button') })] }), _jsx(Flex, { justifyContent: "center", children: _jsx(AuthLink, { href: "/login", children: t('password_reset.to_sign_in_button') }) })] }));
};
export default PasswordForgotForm;
